<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Отправка оповещений</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-tabs expanded type="is-toggle">
          <b-tab-item expanded label="SMS" icon="message">
            <div class="columns">
              <div class="column">
                <b-field label="Время отправки">
                  <b-datetimepicker
                    v-model="settings.sms.planned_at"
                    placeholder="Выбрать время"
                  >
                    <template slot="left">
                      <button
                        class="button is-primary"
                        @click="settings.sms.planned_at = new Date()"
                      >
                        <b-icon icon="clock"></b-icon>
                        <span>Now</span>
                      </button>
                    </template>
                    <template slot="right">
                      <button
                        class="button is-danger"
                        @click="settings.sms.planned_at = null"
                      >
                        <b-icon icon="close"></b-icon>
                        <span>Clear</span>
                      </button>
                    </template>
                  </b-datetimepicker>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Метка рассылки">
                  <b-input v-model="settings.sms.source"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Шаблон">
                        <b-autocomplete
                          :value="settings.sms.notification_template.name"
                          clearable
                          :data="smsTemplates"
                          :keep-first="false"
                          :open-on-focus="true"
                          field="name"
                          @input="option => onTemplateInput(option,'sms')"
                          @select="option => setNotificationTemplate(option, 'sms')">
                          <template #empty> Нет результатов </template>
                        </b-autocomplete>
                    </b-field>
                </div>
            </div>

            <div class="columns">
              <div class="column">
                <b-button
                  type="is-primary"
                  class="is-pulled-right"
                  icon-left="plus"
                  @click="createModal('sms')"
                  >Cоздать уведомление</b-button
                >
              </div>
            </div>
          </b-tab-item>
          <b-tab-item expanded label="Call" icon="phone">
            <div class="columns">
              <div class="column">
                <b-field label="Время отправки">
                  <b-datetimepicker
                    v-model="settings.call.planned_at"
                    placeholder="Выбрать время"
                  >
                    <template slot="left">
                      <button
                        class="button is-primary"
                        @click="settings.call.planned_at = new Date()"
                      >
                        <b-icon icon="clock"></b-icon>
                        <span>Now</span>
                      </button>
                    </template>
                    <template slot="right">
                      <button
                        class="button is-danger"
                        @click="settings.call.planned_at = null"
                      >
                        <b-icon icon="close"></b-icon>
                        <span>Clear</span>
                      </button>
                    </template>
                  </b-datetimepicker>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Метка рассылки">
                  <b-input v-model="settings.call.source"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Шаблон">
                        <b-autocomplete
                          :value="settings.call.notification_template.name"
                          clearable
                          :data="callTemplates"
                          :keep-first="false"
                          :open-on-focus="true"
                          field="name"
                          @input="option => onTemplateInput(option,'call')"
                          @select="option => setNotificationTemplate(option, 'call')">
                          <template #empty> Нет результатов </template>
                        </b-autocomplete>
                    </b-field>
                </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-button
                  type="is-primary"
                  class="is-pulled-right"
                  icon-left="plus"
                  @click="createModal('call')"
                  >Cоздать уведомление</b-button
                >
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
    <CreateNotifications v-bind:params="props"></CreateNotifications>
    <CreateTemplate></CreateTemplate>
  </div>
</template>

<script>
import CreateNotifications from "../shared/modals/createNotifications";
import CreateTemplate from "../../notification_templates/modals/createTemplate.vue";

export default {
  name: "InstantNotifications",
  components: {
    CreateNotifications,
    CreateTemplate,
  },
  created() {
    this.$store.dispatch('GET_TEMPLATES_LIST');
  },
  data() {
    return {
      settings: {
        sms: {
          planned_at: new Date(),
          source: null,
          notification_template: {
              name: '',
          },
        },
        call: {
          planned_at: new Date(),
          source: null,
          notification_template: {
              name: '',
          },
        },
      },
      selectable: true,
      props: {},
    };
  },
    computed: {
    templates() {
      return (this.$store.getters.TEMPLATES_LIST && this.$store.getters.TEMPLATES_LIST.results) || [];
    },
      smsTemplates() {
        return this.templates.filter(
          (t) =>
            t.type === 'sms' &&
            t.name.toLowerCase().includes(
              this.settings.sms.notification_template.name.toLowerCase()
            )
        );
      },
      callTemplates() {
        return this.templates.filter(
          (t) =>
            t.type === 'call' &&
            t.name.toLowerCase().includes(
              this.settings.call.notification_template.name.toLowerCase()
            )
        );
      },
    },
  methods: {
    createModal(channel) {
      if (
        this.settings[channel].notification_template
      ) {
        this.props = {
          channel,
          settings: this.settings[channel],
          user: this.authUser,
          id: null,
        };
        this.$store.dispatch("USER_MODALS", true);
      }
    },
    setNotificationTemplate(option, type) {
        if (option) {
          this.settings[type].notification_template = option;
        } else {
          this.settings[type].notification_template = { name: '' }; // или пустой объект {}
        }
      },
      onTemplateInput(value, type) {
        if (!value) {
          // обнуляем весь объект при очистке
          this.settings[type].notification_template = { name: '' };
        } else {
          // если нужно оставить ввод в поле
          this.settings[type].notification_template.name = value;
        }
      },
  },
};
</script>

<style>
.tabs.is-toggle li.is-active a {
  background-color: #1d8f68;
}
.element-bg-cyan.is-primary {
  background-color: #1d8f68;
}
</style>
